var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDescription)?_c('list-item-description',{attrs:{"description-html":_vm.project.descriptionHtml}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }